export enum BreadcrumbsTheme {
  LIGHT = "light",
  DARK = "dark",
}

export const DEFAULT_MAX_ITEMS = 4;

export const DEFAULT_ITEMS_AFTER_COLLAPSE = 1;

export const DEFAULT_ITEMS_BEFORE_COLLAPSE = 2;
